<template>
    <form :action="requestUri" @submit.prevent="submit(requestUri,'post')" method="post">
        <Modal :open="open" name="create_address" ref="modal" size="lg" @onDismiss="dismiss">
            <ModalHeader><span>افزودن آدرس جدید</span></ModalHeader>
            <ModalBody>
                <div class="form-group mb-3">
                    <simple-text :errors="errors" v-model="form.name" name="name" label="نام تحویل گیرنده" />
                </div>
                <div class="form-group mb-3">
                    <simple-select :errors="errors" :class="{loading: loading_provinces}" :options="provinces" v-model="form.province_id" name="province_id" label="استان" />
                </div>
                <div class="form-group mb-3">
                    <simple-select :errors="errors" :class="{loading: loading_cities}" :disabled="!form.province_id" :options="cities" v-model="form.city_id" name="city_id" label="شهر" />
                </div>
                <div class="form-group mb-3">
                    <simple-textarea :errors="errors" v-model="form.line" name="line" label="آدرس" />
                </div>
                <div class="form-group mb-3">
                    <simple-text :errors="errors" v-model="form.postalcode" name="postalcode" label="کد پستی" />
                </div>
                <div class="form-group mb-3">
                    <simple-text :errors="errors" v-model="form.phone" name="phone" label="تلفن ثابت (به همراه کد شهر)" />
                </div>
                <div class="form-group">
                    <simple-text :errors="errors" v-model="form.mobile" name="mobile" label="شماره همراه" />
                </div>
            </ModalBody>
            <ModalFooter>
                <template v-slot:start>
                    <button class="btn btn-primary" type="submit" :disabled="loading">
                        <span>ایجاد آدرس جدید</span>
                        <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                </template>
                <template v-slot:end>
                    <button type="button" class="btn btn-secondary" @click="$refs.modal.dismiss()">انصراف</button>
                </template>
            </ModalFooter>
        </Modal>
    </form>
</template>

<script>
import {HasModalMixin} from "../general/HasModalMixin";
import SimpleAjaxFormMixin from "../general/SimpleAjaxFormMixin";

export default {
    name: "CreateAddress",
    mixins: [HasModalMixin, SimpleAjaxFormMixin],
    props: ['open'],
    emits: ['update:open', 'onDismiss', 'onCreate'],
    computed: {
        requestUri() {
            return this.route('api.profile.addresses.store');
        },
        provinceId() {
            return this.form.province_id;
        },
    },
    data: () => ({
        form: {
            name: '',
            province_id: null,
            city_id: null,
            postalcode: '',
            line: '',
            phone: '',
            mobile: '',
        },
        provinces: [],
        cities: [],
        loading_provinces: false,
        loading_cities: false,
    }),
    methods: {
        dismiss() {
            this.$emit('update:open', false);
            this.$emit('onDismiss');
        },
        successful(response) {
            this.$refs.modal.dismiss();
            this.$emit('onCreate', response.data.data);
        },
        getProvinces() {
            this.loading_provinces = true;
            this.axios.get(this.route('api.provinces')).then(response => {
                this.provinces = response.data.data.map(province => {
                    return {
                        key: province.id,
                        value: province.name
                    };
                });
                this.loading_provinces = false;
            }).catch(async error => {
                this.loading_provinces = false;
            });
        },
        getCities(province_id) {
            this.loading_cities = true;
            this.axios.get(this.route('api.cities', [province_id])).then(response => {
                this.cities = response.data.data.map(city => {
                    return {
                        key: city.id,
                        value: city.name
                    };
                });
                this.loading_cities = false;
            }).catch(async error => {
                this.loading_cities = false;
            });
        },
    },
    watch: {
        provinceId(value) {
            this.getCities(value);
        }
    },
    mounted() {
        this.getProvinces();
    }
}
</script>

<style scoped>

</style>
